export default __webpack_public_path__ + "static/media/wh_0.4c9a31b1.mp3";